import { AppConstants } from "../constants/AppConstants";
import environment from "../environment";
import BaseAPIClient from "./api";
import env from "../environment";
import { cloneDeep } from "lodash";

const API = BaseAPIClient?.axiosInstance;

// export const generateAdminToken = () => {
//   if (environment.zendeskApi !== "/zendesk-proxies/") {
//     const urlParams = new URLSearchParams(location.hash.substring(1));
//     const accessToken = urlParams.get("access_token");
//     return `Bearer ${accessToken}`;
//   }
//   const zendeskAuthString = `${process.env.REACT_APP_ZENDESK_ADMIN_EMAIL}/token:${process.env.REACT_APP_ZENDESK_API_TOKEN}`;
//   return `Basic ${btoa(zendeskAuthString)}`;
// };

// const init = () => {
//   // details.style.display = "none";
//   const urlParams = new URLSearchParams(location.hash.substring(1));
//   const accessToken = urlParams.get("access_token");
//   if (accessToken) {
//     localStorage.accessToken = accessToken;
//     ticketIdInput.value = localStorage.ticketId;
//     window.location.hash = "";
//     makeRequest(accessToken, ticketIdInput.value);
//   }
// };

export const listTicketForms = async () => {
  const headers = {
    ...AppConstants.GLOBAL_HEADERS,
  };
  const response = await API.get(
    `/${env.zenDeskPath}/ticket-forms?active=true&end_user_visible=true`,
    { headers }
  );
  return response;
};

export const listFields = async () => {
  const headers = {
    ...AppConstants.GLOBAL_HEADERS,
  };
  const response = await API.get(`/${env.zenDeskPath}/ticket-fields`, {
    headers,
  });
  return response;
};

export const createRequest = async (payload: any) => {
  const headers = {
    ...AppConstants.GLOBAL_HEADERS,
  };

  let uri = `/${env.zenDeskPath}/requests`;

  const response = await API.post(uri, payload, { headers });
  return response;
};

export const listRequests = async (
  page: number = AppConstants.DEFAULT_PAGE,
  size: number = AppConstants.DEFAULT_PAGE_SIZE,
  sorters: string = ""
) => {
  const headers = {
    ...AppConstants.GLOBAL_HEADERS,
  };

  let uri = `/${env.zenDeskPath}/list-requests?sort_by=created_at&sort_order=desc&page=${page}&per_page=${size}`;

  if (sorters) {
    uri += `&${sorters}`;
  }

  const response = await API.get(uri, { headers });
  return response;
};

export const listRequestId = async (
  id: number,
) => {
  const headers = {
    ...AppConstants.GLOBAL_HEADERS,
  };

  let uri = `/${env.zenDeskPath}/requests/${id}`;

  const response = await API.get(uri, { headers });
  return response;
};

export const createUser = async () => {
  const headers = {
    ...AppConstants.GLOBAL_HEADERS,
  };
  const uri = `/${env.zenDeskPath}/users`;
  const response = await API.post(uri, {}, { headers });
  return response;
};

export const getUser = async () => {
  const headers = {
    ...AppConstants.GLOBAL_HEADERS,
  };
  const uri = `/${env.zenDeskPath}/users`;
  const response = await API.get(uri, { headers });
  return response;
};

export const updateUser = async () => {
  const headers = {
    ...AppConstants.GLOBAL_HEADERS,
  };
  const uri = ""; //`${env.zendeskApi}api/v2/users/${userId}`;
  // const response = await API.put(uri, payload, { headers });
  // return response;
};
